@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.wrapper {
    align-items: center;
    display: flex;
    flex-direction: column;
}

.container {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    row-gap: 100px;
    margin-bottom: 100px;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        grid-template-columns: 1fr;
    }
}

.link {
    cursor: pointer;
    display: block;
    color: inherit;
    text-decoration: none;

    &:hover {
        // When any part of the link is hovered over
        // add an underline to the title
        & h3 {
            text-decoration: underline;
        }
    }
}

.image {
    display: block;
    margin-bottom: 10px;
}

.date {
    font-size: 1.875rem;
    padding: 0 4%;
}

.title {
    font-size: 2.8125rem;
    font-weight: 700;
    line-height: 1;
    padding: 0 4%;
}

.seeAllLink {
    composes: button from "../../styles/buttons.module.scss";
}
